import ColumnsContent from 'components/Hocs/ColumnsContent';
import RoomMainBlock from 'components/Messenger/content/RoomViewBlock/RoomMainBlock';
import RoomSidebarBlock from 'components/Messenger/content/RoomViewBlock/RoomSidebarBlock';

export default ColumnsContent(RoomMainBlock, RoomSidebarBlock);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyMessages/RoomView/index.js